import React, { useState, useEffect } from "react";
import { CircularProgress, Box } from "@mui/material";

export default function RenderTableReports({ reports }) {
  const [expandedRow, setExpandedRow] = useState(null);
  const [tableLoading, setTableLoading] = useState(true);

  useEffect(() => {
    setTableLoading(true);
    const timer = setTimeout(() => setTableLoading(false), 300); // Small delay to smooth UX
    return () => clearTimeout(timer);
  }, [reports]);

  const handleViewDetails = (billNo) => {
    setExpandedRow(expandedRow === billNo ? null : billNo);
  };

  if (tableLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", my: 5 }}>
        <CircularProgress size={40} />
      </Box>
    );
  }

  return (
    <div className="table-container">
      <table className="data-table">
        <thead>
          <tr>
            <th>Bill No</th>
            <th>Train</th>
            <th>Status</th>
            <th>Payment Mode</th>
            <th>Amount</th>
            <th>Sub Total</th>
            <th>Order Date</th>
            <th>Aggregator</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {reports.length === 0 ? (
            <tr>
              <td colSpan="8" style={{ textAlign: "center" }}>
                No reports found
              </td>
            </tr>
          ) : (
            reports.map((report) => (
              <React.Fragment key={report._id || report.orderId}>
                <tr className="order-row">
                  <td>{report.billNo || "N/A"}</td>
                  <td className="flex-wrap">{report.trainName || "N/A"}</td>
                  <td>
                    <span
                      className={`status-badge ${report.status?.toLowerCase()}`}
                    >
                      {report.status || "N/A"}
                    </span>
                  </td>
                  <td>{report.paymentStatus || "N/A"}</td>
                  <td>₹{report.totalAmount}</td>
                  <td>₹{report.subTotal}</td>
                  <td>{report.orderDate}</td>
                  <td>{report.aggregator}</td>
                  <td className="action-buttons-cell">
                    <button
                      className="view-details-btn btn-sm"
                      onClick={() =>
                        handleViewDetails(report._id || report.orderId)
                      }
                    >
                      {expandedRow === (report._id || report.orderId) ? (
                        <i className="fas fa-eye-slash"></i>
                      ) : (
                        <i className="fas fa-eye"></i>
                      )}
                    </button>
                  </td>
                </tr>

                {expandedRow === (report._id || report.orderId) && (
                  <tr className="order-details">
                    <td colSpan="12">
                      <div className="order-details-content">
                        <h4>Report Details: {report.billNo || "N/A"}</h4>
                        <div className="details-grid">
                          <div>
                            <strong>OrderID:</strong> {report.orderId || "N/A"}
                          </div>
                          <div>
                            <strong>Customer Name:</strong>{" "}
                            {report.customerName || "N/A"}
                          </div>
                          <div>
                            <strong>Customer Mobile:</strong>{" "}
                            {report.mobileNo || "N/A"}
                          </div>
                          <div>
                            <strong>Aggregator:</strong>{" "}
                            {report.aggregator || "N/A"}
                          </div>
                          <div>
                            <strong>Train Number:</strong>{" "}
                            {report.trainNo || "N/A"}
                          </div>
                          <div>
                            <strong>Order Date:</strong> {report.orderDate}
                          </div>

                          {report.items && (
                            <div className="items-section">
                              <strong>Items:</strong>
                              <ul className="items-list d-flex flex-row gap-5 flex-wrap">
                                <div>
                                  {report.items.map((item, index) => (
                                    <li key={index} className="item-entry">
                                      <span className="item-name">
                                        {item.name}
                                      </span>
                                      <span className="item-details">
                                        : {item.qty} x {item.price} ={" "}
                                        {item.qty * item.price}
                                      </span>
                                    </li>
                                  ))}
                                  <li className="subtotal">
                                    <strong>Sub Total: </strong>₹
                                    {report.subTotal}
                                  </li>
                                </div>
                                <div>
                                  <li className="gst">
                                    <strong>GST: </strong>₹{report.gst}
                                  </li>
                                  <li className="discount">
                                    <strong>Discount: </strong>₹
                                    {report.discount}
                                  </li>
                                  <li className="delivery">
                                    <strong>Delivery: </strong>₹
                                    {report.deliveryCharge}
                                  </li>
                                  <li className="total-amount">
                                    <strong>Total Amount: </strong>₹
                                    {report.totalAmount}
                                  </li>
                                </div>
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))
          )}
        </tbody>
      </table>

      {/* Summary */}
      {/* <div className="d-flex justify-content-start">
        <h6 className="p-1">Total Orders: {reports.length}</h6>
        <h6 className="p-1">
          subTotal Revenue: ₹
          {reports
            .filter((order) => order.status?.toLowerCase() !== "cancelled")
            .reduce((acc, order) => acc + (parseFloat(order.subTotal) || 0), 0)}
        </h6>
        <h6 className="p-1">
          Total Revenue: ₹
          {reports
            .filter((order) => order.status?.toLowerCase() !== "cancelled")
            .reduce(
              (acc, order) => acc + (parseFloat(order.totalAmount) || 0),
              0
            )}
        </h6>
        <h6 className="p-1">
          Today Cancelled: ₹
          {reports
            .filter((order) => order.status?.toLowerCase() === "cancelled")
            .reduce(
              (acc, order) => acc + (parseFloat(order.totalAmount) || 0),
              0
            )}
        </h6>
      </div> */}
    </div>
  );
}
